module.exports = __webpack_public_path__ + "img/FUSHENGlogo.2a3efd80.png";